import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ComplianceReportCard = ({ report, onDownload, onView }) => {
  const getStatusColor = () => {
    switch (report?.status) {
      case 'compliant': return 'bg-success/10 text-success';
      case 'warning': return 'bg-warning/10 text-warning';
      case 'non-compliant': return 'bg-error/10 text-error';
      default: return 'bg-muted text-muted-foreground';
    }
  };

  const getStatusIcon = () => {
    switch (report?.status) {
      case 'compliant': return 'CheckCircle';
      case 'warning': return 'AlertTriangle';
      case 'non-compliant': return 'XCircle';
      default: return 'FileText';
    }
  };

  return (
    <div className="bg-card rounded-xl p-4 md:p-5 shadow-elevation-2 border border-border hover:shadow-elevation-3 transition-smooth">
      <div className="flex items-start gap-3 md:gap-4 mb-4">
        <div className="w-10 h-10 md:w-12 md:h-12 rounded-lg bg-primary/10 flex items-center justify-center flex-shrink-0">
          <Icon name="FileText" size={20} className="text-primary" />
        </div>
        <div className="flex-1 min-w-0">
          <h3 className="text-sm md:text-base font-semibold text-foreground mb-1">{report?.title}</h3>
          <p className="text-xs md:text-sm text-muted-foreground mb-2">{report?.description}</p>
          <div className="flex items-center gap-2">
            <Icon name={getStatusIcon()} size={14} className={getStatusColor()?.split(' ')?.[1]} />
            <span className={`text-xs font-medium ${getStatusColor()}`}>
              {report?.status?.charAt(0)?.toUpperCase() + report?.status?.slice(1)}
            </span>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-2 gap-3 md:gap-4 mb-4 p-3 bg-muted/50 rounded-lg">
        <div>
          <p className="text-xs text-muted-foreground mb-1">Report Period</p>
          <p className="text-xs md:text-sm font-medium text-foreground">{report?.period}</p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground mb-1">Generated</p>
          <p className="text-xs md:text-sm font-medium text-foreground">{report?.generatedDate}</p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground mb-1">Compliance Score</p>
          <p className="text-xs md:text-sm font-medium text-foreground">{report?.complianceScore}%</p>
        </div>
        <div>
          <p className="text-xs text-muted-foreground mb-1">Issues Found</p>
          <p className="text-xs md:text-sm font-medium text-foreground">{report?.issuesFound}</p>
        </div>
      </div>
      <div className="flex flex-col sm:flex-row gap-2 md:gap-3">
        <Button
          variant="default"
          size="sm"
          iconName="Eye"
          iconPosition="left"
          onClick={() => onView(report?.id)}
          className="flex-1"
        >
          View Details
        </Button>
        <Button
          variant="outline"
          size="sm"
          iconName="Download"
          iconPosition="left"
          onClick={() => onDownload(report?.id)}
          className="flex-1"
        >
          Download
        </Button>
      </div>
    </div>
  );
};

export default ComplianceReportCard;